import React, { useEffect, useRef, useState } from 'react';

const NumericInputWithArrows = ({
	item,
	handleInputChange,
	className,
	suffix = '%',
	inputKey = 'fraction',
	label = '',
	step = 5,
	errors = null,
	itemId = 'code',
}) => {
	const inputRef = useRef(null);

	const handleClick = (up = true) => {
		if (up && !item[inputKey]) {
			handleInputChange({
				[itemId]: inputRef.current.getAttribute('data-id'),
				[inputKey]: step,
			});
		} else if (up && item[inputKey] < 100 && !errors) {
			handleInputChange({
				[itemId]: inputRef.current.getAttribute('data-id'),
				[inputKey]: item[inputKey] + step,
			});
		} else if (!up && item[inputKey] > 0) {
			handleInputChange({
				[itemId]: inputRef.current.getAttribute('data-id'),
				[inputKey]: item[inputKey] - step,
			});
		}
	};

	return (
		<div
			className={`${className ?? 'input-' + inputKey} ${
				item?.[inputKey] > 0 ? 'is-selected' : ''
			}`}>
			<label htmlFor={item[itemId]} className="input-checkbox-container">
				<input
					type="checkbox"
					className="checkbox"
					id={item[itemId]}
					data-id={item[itemId]}
					checked={item?.[inputKey] > 0 ? true : false}
					onChange={(e) => {
						if (item?.[inputKey] > 0) {
							handleInputChange({
								[itemId]: e.target.getAttribute('data-id'),
								[inputKey]: 0,
							});
						} else {
							handleInputChange({
								[itemId]: e.target.getAttribute('data-id'),
								[inputKey]: 5,
							});
						}
					}}
					style={{ display: 'none' }}
				/>
				<span className="fz fz-check"></span>
				{label}
			</label>
			<div className="input-number-container">
				<button type="button" onClick={() => handleClick(false)}>
					<i className="icon fz-minus" />
				</button>
				<span className="input-number" data-suffix={suffix}>
					<input
						ref={inputRef}
						data-id={item[itemId]}
						type="text"
						inputMode="numeric"
						value={item[inputKey] || 0}
						className="input"
						readOnly={true}
						onChange={(e) => {
							if (e.target.value >= 0 && e.target.value <= 100) {
								handleInputChange({
									[itemId]: e.target.getAttribute('data-id'),
									[inputKey]: e.target.value,
								});
							}
						}}
						step={step}
					/>
				</span>
				<button type="button" onClick={handleClick} disabled={errors}>
					<i className="icon fz-plus" />
				</button>
			</div>
			{errors && (
				<span className="is-invalid fz fz-exclamation-triangle"></span>
			)}
		</div>
	);
};

export default NumericInputWithArrows;
